import type { House } from "@/houses/types";
import { apiClient } from "./apiClient";

export const areaHousesGateway = {
  async getAreaHouses(areaId: string): Promise<Array<House>> {
    return await apiClient.get(
      `/api/areas/${areaId}/houses?include-hidden=true`,
    );
  },
};
